import Tippy from '@tippyjs/react';
import { UserAvatar } from 'components/user-avatar';
import { useAuth } from 'context/AuthContext';
import { format, utcToZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { BiReset } from 'react-icons/bi';
import { FiEdit3, FiEye } from 'react-icons/fi';
import { MdOutlineLock } from 'react-icons/md';
import { HiOutlineHandThumbUp, HiOutlineHandThumbDown } from 'react-icons/hi2';
import { useNavigate } from 'react-router';
import { GetManagerStepLabel, GetManagerTypeLabel, GetTaskLevelLabel } from 'utils/strings';
import ModalActions from './modal-actions';
import { useModal } from 'context/ModalContext';
import { RiMessage2Line } from 'react-icons/ri';
import { deleteTask, getPlayerInfo, submitFeedback, submitFeedbackEcoa } from 'services/dashboard.service';
import { BsTrash } from 'react-icons/bs';
import ModalConfirm from './modal-actions/confirm';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { RiProhibitedLine } from 'react-icons/ri';
import { CyclesInterface, Step } from 'types/user';
import { Countdown } from 'components/countdown';
import Matriz from 'components/matriz';
import { getTaskStep } from 'utils/helpers';
import Humanograma from 'components/Humanograma';
import { LuArrowDownWideNarrow } from 'react-icons/lu';
import { FaEye } from 'react-icons/fa';

// import { updateTask } from 'services/dashboard.service';

interface TaskItemProps {
  data: any;
  playerInfo?: any;
  editable?: boolean;
  canEvaluate?: boolean;
  canValidate?: boolean;
  manager?: boolean;
  managerType?: string;
  promote?: boolean;
  double?: boolean;
  reject?: boolean;
  reset?: boolean;
  cycle?: CyclesInterface | Step;
  activeEvaluationStep?: number | null;
  taskStep?: number | undefined;
  playerStep?: number | undefined;
  isView?: boolean | undefined | null;
  canApproveParticipants?: boolean | undefined | null;
  getAction?: any;
  bonus?: boolean;
  canFinalize?: boolean;
  onPromote?: (task: any) => void;
  onDouble?: (task: any) => void;
  onAccept?: (task: any) => void;
  onReject?: (task: any) => void;
  onKnown?: (task: any) => void;
  onClearStatus?: (task: any, status: any) => void;
  onDelete?: (task: any) => void;
  onFeedback?: (task: any) => void;
  onStop?: (task: any) => void;
  onReset?: (task: any) => void;
  onReload?: (task: any) => void;
  clearGetAction?: () => void;
  ecoa?: boolean;
}

interface managersByStepProps {
  blocks: number;
  chave?: string;
  cod_etapa?: number;
  nome_guerra?: string;
  prosseguir_gst?: number;
  stage: string;
  stageTitle: string;
  stageNumber: number;
}

const getStatusApprovalParticipants: any = {
  autoApproved: 'Número de participantes liberados automaticamente',
  pending: 'Número de participantes pendentes de autorização',
  approved: 'Número de participantes aprovados',
  rejected: 'Número de participantes não aprovados',
};

export function TaskItemEcoa(props: TaskItemProps) {
  const { showModal, closeModal } = useModal();
  const { user, realCycle } = useAuth();
  const navigate = useNavigate();
  const {
    data,
    editable,
    canEvaluate,
    canValidate,
    manager,
    managerType,
    promote,
    double,
    reset,
    playerInfo,
    cycle,
    activeEvaluationStep,
    playerStep,
    isView,
    canApproveParticipants,
    getAction,
    bonus,
    canFinalize,
    onPromote,
    onDouble,
    onAccept,
    onReject,
    onKnown,
    onDelete,
    onFeedback,
    onStop,
    onReset,
    onReload,
    clearGetAction,
    ecoa,
  } = props;

  // const [quizAnswered, setQuizAnswered] = useState<boolean>(!!data?.answeredQuiz);
  const taskStep = getTaskStep(data);

  const [oppened, setOppened] = useState<boolean>(false);
  const [status, setStatus] = useState<any>();
  const [showFeedbacks, setShowFeedbacks] = useState(false);
  // const [hasFeedback, setHasFeedback] = useState<boolean | undefined>();
  // const [showModalMatriz, setShowModalMatriz] = useState<boolean>();
  const [realPlayerInfo, setRealPlayerInfo] = useState<any>();
  const [validateTeamMember, setValidateTeamMember] = useState<string>();
  const [userToChange, setUserToChange] = useState<string | undefined>();

  const hasFeedback = useMemo(
    () =>
      !!Array.isArray(data.feedback) &&
      !!data?.feedback?.find((x: { evaluatorId: any }) => !!realPlayerInfo && x.evaluatorId === realPlayerInfo?.chave),
    [realPlayerInfo, data],
  );
  const isVacationManager = useMemo(() => !!playerInfo && !!user && playerInfo._id !== user.extra.id, [playerInfo, user]);

  const getUserTeam = useCallback(
    (_id: string) => {
      try {
        return data?.team?.find((item: any) => item._id === _id);
      } catch (e) {
        return undefined;
      }
    },
    [data?.team],
  );

  const verifyFeedback = useCallback(() => {
    if (
      data &&
      realPlayerInfo?.chave &&
      (!Array.isArray(data.feedback) || !data.feedback.find((x: { evaluatorId: any }) => x.evaluatorId === realPlayerInfo.chave))
    ) {
      closeModal();
      setTimeout(() => {
        showModal(`validation-feedback-${data._id}`);
      }, 150);
    }
  }, [closeModal, data, realPlayerInfo, showModal]);

  async function handleReset(task: any) {
    if (onReset && !!task && task._id) {
      onReset(task);
    }
  }

  async function handleReload() {
    if (onReload && !!data && data._id) {
      onReload(data._id);
    }
  }

  async function handleAccept() {
    // if (status) return;

    // if (!confirm('Você confirma que deseja validar esta entrega?')) return;

    // const updatedData = {...data, status : "aprovado", team: [...data.team,{_id:user._id}]}
    // await updateTask(updatedData);
    if (onAccept) {
      onAccept(data);
      // setStatus('aprovado');
    }
  }

  async function handlePromote() {
    // if (status) return;

    // if (!confirm('Você confirma que deseja promover esta entrega?')) return;

    if (onPromote) {
      onPromote(data);
      // setStatus('próximo nível');
    }
  }

  async function handleDouble() {
    // if (status) return;

    // if (!confirm('Você confirma que deseja dobrar esta entrega?')) return;

    if (onDouble) {
      onDouble(data);
      setStatus('dobrado');
    }
  }

  async function handleReject() {
    // if (status) return;

    // if (!confirm('Você confirma que deseja devolver esta entrega?')) return;

    // const updatedData = {...data, status : "rejeitado"}
    // await updateTask(updatedData);
    if (onReject) {
      onReject(data);
      setStatus('rejeitado');
    }
  }

  async function handleKnown() {
    // if (status) return;

    // if (!confirm('Você confirma que deseja devolver esta entrega?')) return;

    // const updatedData = {...data, status : "rejeitado"}
    // await updateTask(updatedData);
    if (onKnown) {
      onKnown(data);
      setStatus('ciente');
    }
  }

  async function handleDelete(data: string) {
    await deleteTask(data, ecoa);

    if (onDelete) onDelete(data);
  }

  async function handleStop() {
    if (onStop) {
      onStop(data);
      setStatus('concluido');
    }
  }

  async function handleFeedback(msg: string) {
    // eslint-disable-next-line no-debugger
    debugger;
    if (!msg || !msg.trim().length) return;

    try {
      const payload: any = {
        message: msg.trim(),
        taskId: data._id,
        evaluatorId: realPlayerInfo.chave,
        evaluator_nome: realPlayerInfo.nome,
        evaluator_nome_guerra: realPlayerInfo.nome_guerra,
        evaluator_email: realPlayerInfo.email,
        etapa: activeEvaluationStep,
      };

      if (isVacationManager) {
        payload.original_task_manager = {
          playerId: playerInfo.chave,
          playerName: playerInfo.nome,
        };
      }

      await submitFeedbackEcoa(payload);
      if (onFeedback) onFeedback(data);
      // setHasFeedback(true);
    } catch (error) {}
  }

  function handleEdit() {
    navigate(data._id);
  }

  function getFormattedDate(value: any) {
    try {
      return format(utcToZonedTime(value, 'GMT'), 'dd/MM/yy');
    } catch (e) {
      return '---';
    }
  }

  const has100Points = useMemo(() => {
    if (!!data && data.created >= +new Date('2023-07-31T03:00:00.000Z')) {
      if (
        !!data &&
        !!data.multiplicador &&
        !!data.stageNumber &&
        (data.status === 'promovido' || data.status === 'concluido') &&
        ((data.stageNumber === 2 && data.multiplicador === 2) || (data.stageNumber === 3 && data.multiplicador === 4))
      ) {
        return true;
      }

      if (!!data && data.status === 'selo') {
        return true;
      }
    }

    return false;
  }, [data]);

  const canViewResetButton: boolean = useMemo((): boolean => {
    // // eslint-disable-next-line no-debugger
    // debugger
    if (!reset || !activeEvaluationStep || !!isView) return false;

    if (
      data.status === 'rejeitado' ||
      data.status === 'dobrado' ||
      data.status === 'selo' ||
      data.status === 'concluido' ||
      data.status === 'concluidoAuto' ||
      data.status === 'ciente' ||
      (typeof taskStep === 'number' && taskStep > activeEvaluationStep)
    ) {
      if (
        data?.evaluatedBy?.length > 0 &&
        (!data.multiplicador || data.multiplicador === 0 || data.multiplicador === 1) &&
        data.evaluatedBy[0] === playerInfo._id
      ) {
        return true;
      }

      if (data?.evaluatedBy?.length > 1 && taskStep === 3 && data.evaluatedBy[1] === playerInfo._id) {
        return true;
      }
    }

    // if (typeof data.prosseguir_gst === 'string' && data.prosseguir_gst !== 'next') {
    //   return true;
    // }

    // if (typeof data.multiplicador === 'number') {
    //   if (data.multiplicador === 1 && activeEvaluationStep === 2) {
    //     return true;
    //   }

    //   if (data.status === 'promovido' && data.multiplicador === 2 && activeEvaluationStep === 3) {
    //     return true;
    //   }

    //   if (data.status === 'promovido' && data.multiplicador === 4 && activeEvaluationStep === 4) {
    //     return true;
    //   }

    //   return false;
    // }

    return false;
  }, [activeEvaluationStep, data, isView, playerInfo._id, reset, taskStep]);

  const pitStopCanEvaluate = useMemo(() => {
    if (!!isView) return false;

    if (manager && canEvaluate && reset) {
      if (!data.prosseguir_idGestor || !data.prosseguir_gst || data.prosseguir_idGestor !== playerInfo._id) return false;

      if (data.prosseguir_gst === 'next') {
        return true;
      }

      return false;
    } else {
      return false;
    }
  }, [manager, canEvaluate, reset, data, playerInfo, isView]);

  const getStepLabel = (step: number) => {
    switch (step) {
      case 2:
        return 'Validação';
      case 1:
        return 'Nível 1';
      case 3:
        return 'Nível 1';
      case 4:
        return 'Nível 2';
      case 4.1:
        return 'Prosseguir';
      case 5:
        return 'Nível 3';
      default:
        return '';
    }
  };

  // Matriz de apreciação - Não excluir
  // const userQuizAnswered = useMemo(() => !!data?.answeredQuiz || !!quizAnswered, [data, quizAnswered]);

  function isCurrentEvaluator() {
    if (!playerInfo || !data.evaluator || !data.evaluator.length || !!isView) return false;

    const matriculaEvaluator = parseInt(data.evaluator[data.evaluator.length - 1].replace(/F(0+)?/g, ''));

    const currentId = parseInt(playerInfo._id);

    return matriculaEvaluator === currentId && data.status === 'promovido';
  }

  function callBackActions(obj: { [key: string]: any }) {
    if (!obj?.id) return;

    if (obj.id === 'accept') {
      handleAccept();
      verifyFeedback();
    } else if (obj.id === 'double') {
      handleDouble();
      verifyFeedback();
    } else if (obj.id === 'feedback') {
      handleFeedback(obj.message as string);
    } else if (obj.id === 'reject') {
      handleReject();
    } else if (obj.id === 'known') {
      handleKnown();
    } else if (obj.id === 'promote' || obj.id === 'selo') {
      handlePromote();
    } else if (obj.id === 'open_feedback') {
      verifyFeedback();
    } else if (obj.id === 'stop') {
      handleStop();
      verifyFeedback();
    } else if (obj.id === 'reset') {
      handleReset(obj.task);
    } else if (obj.id === 'stop_quiz') {
      // Matriz de apreciação - Não excluir
      // setQuizAnswered(true);
      // handleReload();
    } else if (obj.id === 'reload_task') {
      handleReload();
    }
  }

  // const loadFeedback = useCallback(async () => {
  //   if (!!realPlayerInfo && realPlayerInfo.cod_etapa > 0) {
  //     const hasFeedback = await playerHasFeedback(data._id, realPlayerInfo.chave);
  //     setHasFeedback(hasFeedback);
  //   }
  // }, [realPlayerInfo, data]);

  const canViewBoxActions = (): boolean => {
    if (manager && canEvaluate && !isView) {
      if (!reset) return false;

      if (!bonus && (data.status === 'concluido' || data.status === 'concluidoAuto')) return false;

      if (!promote && !double && status === 'aprovado') {
        return true;
      }

      if (status === 'rejeitado') {
        return true;
      }

      if (!data.stageNumber && (!status || status === 'aguardando')) {
        return true;
      }

      if (double) {
        return true;
      }

      if (promote) {
        return true;
      }

      return false;

      return false;
    } else if (
      !!canApproveParticipants &&
      ((data?.participants_approval?.status === 'pending' && cycle?.status === 'open') ||
        data?.participants_approval?.status === 'approved' ||
        data?.participants_approval?.status === 'rejected')
    ) {
      return true;
    }

    return false;
  };

  const canSendFeedback = (): boolean => {
    if (
      !reset ||
      !activeEvaluationStep ||
      !!isView /*||
      (!!data?.prosseguir_idGestor && data.prosseguir_idGestor === playerInfo._id)*/
    ) {
      return false;
    }

    if (!hasFeedback) {
      return true;
    }

    return false;
  };

  const getEvaluatorData = (item: any) => {
    if (item.evaluator_detail?.length) {
      const evaluator = item.evaluator_detail.find((x: { _id: any }) => x._id === item.evaluator[item.evaluator.length - 1]);

      return !!evaluator ? evaluator : undefined;
    }

    return undefined;
  };

  const evaluationData = useMemo(() => {
    if (!!canApproveParticipants) {
      if (data?.participants_approval?.status === 'pending' && cycle?.status === 'open') {
        return (
          <div className="msg-countdown actual">
            <div>
              <p>
                Esta ação está <strong>pendente</strong> de autorização da quantidade de participantes.
              </p>
            </div>
          </div>
        );
      } else if (data?.participants_approval?.status === 'pending' && cycle?.status !== 'open') {
        return (
          <div className="msg-countdown">
            <div>
              <p>O período para avaliação da quantidade de participantes desta ação se encerrou.</p>
            </div>
          </div>
        );
      } else if (data?.participants_approval?.status === 'approved') {
        return (
          <div className="msg-countdown">
            <div>
              <p>
                A quantidade de participantes desta ação foi <strong>autorizada</strong>.
              </p>
            </div>
          </div>
        );
      } else if (data?.participants_approval?.status === 'rejected') {
        return (
          <div className="msg-countdown">
            <div>
              <p>
                A quantidade de participantes desta ação <strong>não foi autorizada</strong>.
              </p>
            </div>
          </div>
        );
      }

      return <></>;
    }

    if (!cycle || !activeEvaluationStep || !taskStep || !playerStep || cycle.status !== 'evaluation' || !!isView) return <></>;

    const date_finish =
      activeEvaluationStep === 2
        ? cycle.evaluation_ecoa_days_step2_finish
        : activeEvaluationStep === 3
          ? cycle.date_evaluation_step3_finish
          : activeEvaluationStep === 4
            ? cycle.date_evaluation_step4_finish
            : activeEvaluationStep === 4.1
              ? cycle.date_evaluation_pitStop_finish
              : cycle.date_evaluation_step5_finish;

    // Se já terminou o prazo e concluiu a validação
    if (!reset && (playerStep as number) < activeEvaluationStep && (taskStep as number) > (playerStep as number)) {
      return (
        <div className="msg-countdown">
          <div>
            <p>Você concluiu a apreciação dessa ação.</p>
          </div>
        </div>
      );
    }

    // Se já terminou o prazo e não concluiu a validação
    else if (!reset && (playerStep as number) < activeEvaluationStep && (taskStep as number) <= (playerStep as number)) {
      return (
        <div className="msg-countdown">
          <div>
            <p>O período para apreciação dessa ação se encerrou.</p>
          </div>
        </div>
      );
    }

    // Se está na etapa atual
    else if (!!reset && (playerStep as number) === activeEvaluationStep) {
      if (data?.participants_approval?.status === 'pending' || data?.participants_approval?.status === 'rejected') {
        return (
          <div className="msg-countdown rejected">
            <div>
              <p>
                A quantidade de participantes <strong>não foi autorizada</strong>.
              </p>
            </div>
          </div>
        );
      }

      return (
        <div className="msg-countdown actual">
          <div>
            <p>
              O período para apreciação dessa ação termina em:{' '}
              <strong className="whitespace-nowrap">
                <Countdown deadline={new Date(date_finish)} />
              </strong>
            </p>
          </div>
        </div>
      );
    }

    // Ele é etapa posterior e o período vai chegar
    else if ((playerStep as number) > activeEvaluationStep && (taskStep as number) > activeEvaluationStep) {
      const date_start_evaluation =
        playerStep === 2
          ? cycle.evaluation_ecoa_days_step2_start
          : playerStep === 3
            ? cycle.date_evaluation_step5_start
            : playerStep === 4
              ? cycle.date_evaluation_step5_start
              : playerStep === 4.1
                ? cycle.date_evaluation_step5_start
                : playerStep === 5
                  ? cycle.date_evaluation_step5_start
                  : null;

      return (
        <div className="msg-countdown">
          <div>
            <p>
              O período para apreciação dessa ação inicia em
              {!!date_start_evaluation ? (
                <>
                  :{' '}
                  <strong className="whitespace-nowrap">
                    <Countdown deadline={new Date(date_start_evaluation)} />
                  </strong>
                </>
              ) : (
                ' breve.'
              )}
            </p>
          </div>
        </div>
      );
    }
  }, [data, activeEvaluationStep, cycle, playerStep, reset, taskStep, isView, canApproveParticipants]);

  const activeStage = useMemo(() => {
    if (!playerInfo || !taskStep) {
      return 0;
    }

    if (taskStep === 2) {
      return 0;
    } else if (taskStep === 3) {
      return 1;
    } else if (taskStep === 4) {
      return 2;
    } else if (taskStep === 4.1 || taskStep === 5) {
      return 3;
    } else {
      return 0;
    }
  }, [playerInfo, taskStep]);

  const getManagerName = useCallback(() => {
    if (!taskStep) return;

    const arrayGestores = [data?.original_manager_detail, data?.evaluator_detail?.[0]].filter(x => !!x) as any[];

    const dataEvaluatorDetail = [...(Array.isArray(data.evaluator) && data.evaluator.length ? data.evaluator : [])]
      .filter(x => !!x.match(/^\d+$/gi))
      .map(x => data?.evaluator_detail?.find((e: any) => e._id === x));

    const evaluators: any = {
      lvl_0:
        data.evaluatedBy?.length > 0 && data?.evaluator_detail?.find((x: any) => x._id === data.evaluatedBy[0])
          ? data?.evaluator_detail?.find((x: any) => x._id === data.evaluatedBy[0])
          : data.evaluatedBy?.length > 0
            ? data?.original_manager_detail
            : arrayGestores,
      lvl_1:
        data.evaluatedBy?.length > 1 && data?.evaluator_detail?.find((x: any) => x._id === data.evaluatedBy[1])
          ? data?.evaluator_detail?.find((x: any) => x._id === data.evaluatedBy[1])
          : data.evaluatedBy?.length > 1
            ? data?.original_manager_detail
            : arrayGestores,
      lvl_2: null,
      lvl_3: null,
    };

    return evaluators;
  }, [data, taskStep]);

  const managersByStep: managersByStepProps[] | undefined = useMemo(() => {
    if (!data || /*!data.gestores ||*/ typeof taskStep !== 'number' || !cycle) return undefined;

    // const dataGestores = {
    //   gestor1: {
    //     chave: data.gestores.chave,
    //     nome_guerra: data.gestores.nome_guerra,
    //     cod_etapa: data.gestores.cod_etapa,
    //     prosseguir_gst: data.gestores.prosseguir_gst,
    //   },
    //   ...data.gestores,
    // };
    // const managersKeys = Object.keys(dataGestores).filter(x => !!x.match(/gestor/g));
    // const managers: managersByStepProps[] = [];

    // managersKeys.forEach((key, index) => {
    //   const manager = dataGestores[key];
    //   const obj = { ...manager };

    //   // Etapa
    //   if (managers.length && !!managers[index - 1] && managers[index - 1].prosseguir_gst === 1 && obj.cod_etapa !== 5) {
    //     return;
    //   } else {
    //     if (obj.cod_etapa === 2) {
    //       obj.stageTitle = 'Validação';
    //       obj.stage = 'stage0';
    //       obj.stageNumber = 0;
    //       obj.blocks = 1;
    //     } else if (obj.cod_etapa === 3 || obj.cod_etapa === 1) {
    //       if (managers.length) {
    //         obj.stageTitle = 'Nível 1';
    //         obj.stage = 'stage1';
    //         obj.stageNumber = 1;
    //         obj.blocks = 2;
    //       } else {
    //         obj.stageTitle = `Validação`;
    //         obj.stage = 'stage0';
    //         obj.stageNumber = 0;
    //         obj.blocks = 1;
    //       }
    //     } else if (obj.cod_etapa === 4) {
    //       obj.stageTitle = 'Nível 2';
    //       obj.stage = 'stage2';
    //       obj.stageNumber = 2;
    //       obj.blocks = 2;
    //     } else if (obj.cod_etapa === 5) {
    //       obj.stageTitle = 'Nível 3';
    //       obj.stage = 'stage3';
    //       obj.stageNumber = 3;
    //       obj.blocks = 2;
    //     }
    //   }

    //   if (obj.cod_etapa === 5) {
    //     const hasStep5 = !!managers.length && !!managers.find((x: { cod_etapa?: number }) => x.cod_etapa && x.cod_etapa === 5);

    //     if (!hasStep5) {
    //       managers.push(obj);
    //     }
    //   } else {
    //     managers.push(obj);
    //   }
    // });

    // const managerStep0 = managers.find((x: { stageNumber: number }) => x.stageNumber === 0);

    // if (
    //   !!managerStep0 &&
    //   (managerStep0.cod_etapa === 3 || managerStep0.cod_etapa === 1) &&
    //   !managers.find((x: { stageNumber: number }) => x.stageNumber === 1)
    // ) {
    //   managers.push({
    //     ...managerStep0,
    //     stageTitle: 'Nível 1',
    //     stage: 'stage1',
    //     stageNumber: 1,
    //     blocks: 1,
    //   });
    // }

    // managers.sort((a: any, b: any) => a.stageNumber - b.stageNumber);

    // return managers;

    // Deixando estático
    return [
      {
        stageTitle: 'Validação',
        stage: 'stage0',
        stageNumber: 0,
        blocks: 1,
      },
      {
        stageTitle: 'Bonificação',
        stage: 'stage1',
        stageNumber: 1,
        blocks: 1,
      },
    ];
  }, [data, taskStep, cycle]);

  const timelineObj: any = useMemo(() => {
    if (!data || !realCycle || !taskStep) return undefined;

    const stepTask = cycle
      ? cycle
      : realCycle
          .find(x => data.created > x.date_start && data.created <= x.date_end)
          ?.steps.find(x => data.created > x.date_start && data.created <= x.date_finish);
    const actualTime = +new Date();

    if (!stepTask) return undefined;

    const stage0: any = { opened: true, titleColor: '#FFFFFF', bgColor: '#C7D3EB' },
      stage1: any = { opened: false, titleColor: '#597B95', bgColor1: '#C7D3EB', bgColor2: '#C7D3EB' },
      stage2: any = { opened: false, titleColor: '#597B95', bgColor1: '#C7D3EB', bgColor2: '#C7D3EB' },
      stage3: any = { opened: false, titleColor: '#597B95', bgColor1: '#C7D3EB', bgColor2: '#C7D3EB' };

    // Gerente de equipe
    if (data.status === 'aguardando' && actualTime <= stepTask.evaluation_ecoa_days_step2_finish) {
      stage0.status = 'Aguardando validação';
      stage0.statusColor = '#FFFFFF';
      stage0.gestor = getManagerName().lvl_0;
    } else if (data.status === 'aguardando' && actualTime > stepTask.evaluation_ecoa_days_step2_finish) {
      stage0.status = 'Prazo expirado';
      stage0.statusColor = '#FDC81C';
      stage0.bgColor = '#FDC81C';
      stage0.gestor = getManagerName().lvl_0;
    } else if (data.status === 'rejeitado') {
      stage0.status = 'Devolvida';
      stage0.statusColor = '#ED2B48';
      stage0.bgColor = '#ED2B48';

      if (Array.isArray(data.feedback) && !!data.feedback.find((x: { evaluatorId: string }) => x.evaluatorId === 'F0000000')) {
        // stage0.gestor = null;
      } else {
        stage0.gestor = getManagerName().lvl_0;
      }
    } else if (data.multiplicador && data.multiplicador >= 1) {
      stage0.status = 'Validada';
      stage0.statusColor = '#04D475';
      stage0.bgColor = '#04D475';
      stage0.gestor = getManagerName().lvl_0;
    } else if (data.status === 'ciente') {
      stage0.status = 'Ciente';
      stage0.statusColor = '#04D475';
      stage0.bgColor = '#04D475';
      stage0.gestor = getManagerName().lvl_0;
    }

    if (data.status === 'rejeitado' || (data.multiplicador && data.multiplicador >= 1)) {
      if (Array.isArray(data.feedback) && !!data.feedback.find((x: { evaluatorId: string }) => x.evaluatorId === 'F0000000')) {
        // stage0.gestor = null;
      } else {
        stage0.gestor = getManagerName().lvl_0;
      }
    }

    // Nível 1
    if (taskStep > 2) {
      stage1.opened = true;
      stage1.titleColor = '#FFFFFF';

      if (
        data.status === 'aprovado' &&
        data.multiplicador &&
        data.multiplicador === 1 &&
        actualTime <= stepTask.date_evaluation_step5_finish
      ) {
        stage1.status = 'Aguardando apreciação';
        stage1.statusColor = '#FFFFFF';
        stage1.gestor = getManagerName().lvl_1;
      }
      // else if (
      //   data.status === 'aprovado' &&
      //   data.multiplicador &&
      //   data.multiplicador === 1 &&
      //   actualTime > stepTask.date_evaluation_step5_finish
      // ) {
      //   stage1.status = 'Prazo expirado';
      //   stage1.statusColor = '#FDC81C';
      //   stage1.bgColor1 = '#FDC81C';
      //   stage1.bgColor2 = '#FDC81C';
      //   stage1.gestor = getManagerName().lvl_0;
      // }
      else if (
        data.status === 'aprovado' &&
        data.multiplicador &&
        data.multiplicador === 1 &&
        actualTime > stepTask.date_evaluation_step5_finish
      ) {
        stage1.status = 'Aguardando apreciação';
        stage1.statusColor = '#FFFFFF';
        stage1.gestor = getManagerName().lvl_1;
      } else if (
        (data.status === 'concluido' || data.status === 'concluidoAuto') &&
        data.multiplicador &&
        data.multiplicador === 1 &&
        taskStep === 3
      ) {
        stage1.status = 'Validada - Finalizada';
        stage1.statusColor = '#7CFFEB';
        stage1.gestor = getManagerName().lvl_1;
      } else if (
        data.status === 'dobrado' &&
        data.multiplicador &&
        data.multiplicador === 2 &&
        actualTime <= stepTask.date_evaluation_step3_finish
      ) {
        stage1.status = 'Bonificada';
        stage1.statusColor = '#04D475';
        stage1.bgColor1 = '#04D475';
        stage1.gestor = getManagerName().lvl_1;
      } else if (
        data.status === 'dobrado' &&
        data.multiplicador &&
        data.multiplicador === 2 &&
        actualTime > stepTask.date_evaluation_step3_finish
      ) {
        stage1.status = 'Bonificada - Prazo expirado';
        stage1.statusColor = '#04D475';
        stage1.bgColor1 = '#04D475';
        stage1.bgColor2 = '#FDC81C';
        stage1.gestor = getManagerName().lvl_1;
      } else if (
        (data.status === 'concluido' || data.status === 'concluidoAuto') &&
        data.multiplicador &&
        data.multiplicador === 2 &&
        taskStep === 3
      ) {
        stage1.status = 'Bonificada - Finalizada';
        stage1.statusColor = '#04D475';
        stage1.bgColor1 = '#04D475';
        stage1.gestor = getManagerName().lvl_1;
      } else if (data.multiplicador && data.multiplicador >= 2 && taskStep > 3) {
        stage1.status = 'Promovida';
        stage1.statusColor = '#04D475';
        stage1.bgColor1 = '#04D475';
        stage1.bgColor2 = '#04D475';
        stage1.gestor = getManagerName().lvl_1;
      } else if (data.status === 'dobrado' && data.multiplicador && data.multiplicador === 3) {
        stage1.status = 'Bonificada';
        stage1.statusColor = '#04D475';
        stage1.bgColor1 = '#04D475';
        stage1.bgColor2 = '#04D475';
        stage1.gestor = getManagerName().lvl_1;
      }
    }

    // Nível 2
    if (taskStep > 3) {
      stage2.opened = true;
      stage2.titleColor = '#FFFFFF';

      if (
        data.status === 'promovido' &&
        data.multiplicador &&
        data.multiplicador === 2 &&
        actualTime <= stepTask.date_evaluation_step4_finish
      ) {
        stage2.status = 'Aguardando apreciação';
        stage2.statusColor = '#FFFFFF';
        stage2.gestor = getManagerName().lvl_2;
      } else if (
        data.status === 'promovido' &&
        data.multiplicador &&
        data.multiplicador === 2 &&
        actualTime > stepTask.date_evaluation_step4_finish
      ) {
        stage2.status = 'Prazo expirado';
        stage2.statusColor = '#FDC81C';
        stage2.bgColor1 = '#FDC81C';
        stage2.bgColor2 = '#FDC81C';
        stage2.gestor = getManagerName().lvl_2;
      } else if (data.status === 'concluido' && data.multiplicador && data.multiplicador === 2 && taskStep === 4) {
        stage2.status = 'Promovida ao nível 2 - Finalizada';
        stage2.statusColor = '#7CFFEB';
        stage2.gestor = getManagerName().lvl_2;
      } else if (
        data.status === 'dobrado' &&
        data.multiplicador &&
        data.multiplicador === 4 &&
        actualTime <= stepTask.date_evaluation_step4_finish
      ) {
        stage2.status = 'Bonificada';
        stage2.statusColor = '#04D475';
        stage2.bgColor1 = '#04D475';
        stage2.gestor = getManagerName().lvl_2;
      } else if (
        data.status === 'dobrado' &&
        data.multiplicador &&
        data.multiplicador === 4 &&
        actualTime > stepTask.date_evaluation_step4_finish
      ) {
        stage2.status = 'Bonificada - Prazo expirado';
        stage2.statusColor = '#04D475';
        stage2.bgColor1 = '#04D475';
        stage2.bgColor2 = '#FDC81C';
        stage2.gestor = getManagerName().lvl_2;
      } else if (
        (data.status === 'concluido' || data.status === 'concluidoAuto') &&
        data.multiplicador &&
        data.multiplicador === 4 &&
        taskStep === 4
      ) {
        stage2.status = 'Bonificada - Finalizada';
        stage2.statusColor = '#04D475';
        stage2.bgColor1 = '#04D475';
        stage2.gestor = getManagerName().lvl_2;
      } else if (data.multiplicador && data.multiplicador >= 4 && taskStep > 4) {
        stage2.status = 'Promovida';
        stage2.statusColor = '#04D475';
        stage2.bgColor1 = '#04D475';
        stage2.bgColor2 = '#04D475';
        stage2.gestor = getManagerName().lvl_2;
      }
    }

    // Nível 3
    if (taskStep > 4) {
      stage3.opened = true;
      stage3.titleColor = '#FFFFFF';

      if (
        data.status === 'promovido' &&
        data.multiplicador &&
        data.multiplicador === 4 &&
        actualTime <= stepTask.date_evaluation_step5_finish
      ) {
        stage3.status = 'Aguardando apreciação';
        stage3.statusColor = '#FFFFFF';
        stage3.gestor = getManagerName().lvl_3;
      } else if (
        data.status === 'promovido' &&
        data.multiplicador &&
        data.multiplicador === 4 &&
        actualTime > stepTask.date_evaluation_step5_finish
      ) {
        stage3.status = 'Prazo expirado';
        stage3.statusColor = '#FDC81C';
        stage3.bgColor1 = '#FDC81C';
        stage3.bgColor2 = '#FDC81C';
        stage3.gestor = getManagerName().lvl_3;
      } else if (data.status === 'concluido' && data.multiplicador && data.multiplicador === 4) {
        stage3.status = 'Promovida ao nível 3 - Finalizada';
        stage3.statusColor = '#7CFFEB';
        stage3.gestor = getManagerName().lvl_3;
      } else if (
        data.status === 'dobrado' &&
        data.multiplicador &&
        data.multiplicador === 8 &&
        actualTime <= stepTask.date_evaluation_step5_finish
      ) {
        stage3.status = 'Bonificada';
        stage3.statusColor = '#04D475';
        stage3.bgColor1 = '#04D475';
        stage3.gestor = getManagerName().lvl_3;
      } else if (
        data.status === 'dobrado' &&
        data.multiplicador &&
        data.multiplicador === 8 &&
        actualTime > stepTask.date_evaluation_step5_finish
      ) {
        stage3.status = 'Bonificada - Prazo expirado';
        stage3.statusColor = '#04D475';
        stage3.bgColor1 = '#04D475';
        stage3.bgColor2 = '#FDC81C';
        stage3.gestor = getManagerName().lvl_3;
      } else if (
        (data.status === 'concluido' || data.status === 'concluidoAuto') &&
        data.multiplicador &&
        data.multiplicador === 8
      ) {
        stage3.status = 'Bonificada - Finalizada';
        stage3.statusColor = '#04D475';
        stage3.bgColor1 = '#04D475';
        stage3.gestor = getManagerName().lvl_3;
      } else if (data.status === 'selo') {
        stage3.status = 'Premiada - Finalizada';
        stage3.statusColor = '#04D475';
        stage3.bgColor1 = '#04D475';
        stage3.bgColor2 = '#04D475';
        stage3.gestor = getManagerName().lvl_3;
      }
    }

    if (!!data.original_manager_detail && data.original_manager_detail?.cod_etapa === 5) {
      if (
        data.status === 'aguardando' &&
        (((data.original_manager_detail?.cod_funcao === 3001 || data.original_manager_detail?.cod_funcao === 3002) &&
          actualTime <= stepTask.date_evaluation_step5_finish) ||
          (data.original_manager_detail?.cod_funcao !== 3001 &&
            data.original_manager_detail?.cod_funcao !== 3002 &&
            actualTime < stepTask.date_evaluation_step5_start))
      ) {
        stage0.status = 'Aguardando validação';
        stage0.statusColor = '#FFFFFF';
        stage0.bgColor = '#C7D3EB';
      }

      if (
        taskStep > 2 &&
        data.status === 'aprovado' &&
        data.multiplicador &&
        data.multiplicador === 1 &&
        (((data.original_manager_detail?.cod_funcao === 3001 || data.original_manager_detail?.cod_funcao === 3002) &&
          actualTime <= stepTask.date_evaluation_step5_finish) ||
          (data.original_manager_detail?.cod_funcao !== 3001 &&
            data.original_manager_detail?.cod_funcao !== 3002 &&
            actualTime < stepTask.date_evaluation_step5_start))
      ) {
        stage1.opened = true;
        stage1.titleColor = '#FFFFFF';
        stage1.status = 'Aguardando apreciação';
        stage1.statusColor = '#FFFFFF';
        stage1.bgColor1 = '#C7D3EB';
        stage1.bgColor2 = '#C7D3EB';
      }
    }

    return { stage0, stage1, stage2, stage3 };
  }, [cycle, data, getManagerName, realCycle, taskStep]);

  const timeline = useCallback(
    (manager: managersByStepProps) => {
      if (!!manager?.stage && !!timelineObj && !!timelineObj[manager?.stage]) return timelineObj[manager.stage];
      else return undefined;
    },
    [timelineObj],
  );

  const doubleByPassCod5: boolean = useMemo(() => {
    if (String(data.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return true;
      } else {
        // Diretores e gerentes gerais
        if (activeEvaluationStep && activeEvaluationStep < 5) {
          return true;
        } else {
          return false;
        }
      }
    }

    return false;
  }, [activeEvaluationStep, data, playerInfo]);

  const canDecreaseParticipation = useCallback(
    (member: any) => {
      const gestor = !!member?.gestor ? `F${member?.gestor?.padStart(7, '0')}` : member._id;

      if (
        cycle &&
        cycle.status !== 'closed' &&
        (user?._id === member._id || user?._id === gestor) &&
        !!getUserTeam(member._id)?.percent &&
        getUserTeam(member._id).percent > 10 &&
        member._id !== data.owner &&
        !managerType
      ) {
        return true;
      }

      return false;
    },
    [cycle, user, data, getUserTeam, managerType],
  );

  const canExcludeParticipation = useCallback(
    (member: any) => {
      // Regra antiga
      // if (
      //   cycle &&
      //   cycle.status === 'open' &&
      //   data.now &&
      //   data.now < cycle.date_evaluation_step2_start &&
      //   user?._id === member._id &&
      //   user?._id !== data.owner &&
      //   (data.status === 'aguardando' || data.status === 'rejeitado')
      // ) {
      //   return true;
      // }

      const gestor = !!member?.gestor ? `F${member?.gestor?.padStart(7, '0')}` : member._id;

      if (
        cycle &&
        cycle.status !== 'closed' &&
        (user?._id === member._id || user?._id === gestor) &&
        member._id !== data.owner &&
        !managerType
      ) {
        return true;
      }

      return false;
    },
    [cycle, user, data, managerType],
  );

  const isParticipantManager = useCallback(
    (member: any) => {
      if (!member?.gestor || !user) {
        return false;
      }

      const gestor = `F${member?.gestor?.padStart(7, '0')}`;

      return user?._id === gestor;
    },
    [user],
  );

  // const canViewBoxApproveTeamMember = useCallback(
  //   (targetMember: any) => {
  //     if (targetMember?.gestor && playerInfo?._id && targetMember.gestor === playerInfo?._id) {
  //       const teamMember = data.team.find((x: { _id: any }) => x._id === targetMember._id);

  //       if (!!teamMember && !!teamMember.requiresApproval && typeof teamMember.approvedByManager === 'undefined') {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     }

  //     return false;
  //   },
  //   [data, playerInfo],
  // );

  // const showMessageRequiresApproval = useCallback(
  //   (targetMember: any) => {
  //     if (targetMember?.gestor && playerInfo?._id && targetMember.gestor === playerInfo?._id) return false;

  //     const teamMember = data.team.find((x: { _id: any }) => x._id === targetMember._id);

  //     if (!!teamMember && !!teamMember.requiresApproval && typeof teamMember.approvedByManager === 'undefined') {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   },
  //   [data, playerInfo],
  // );

  const questionTitle = useMemo(() => {
    if (pitStopCanEvaluate) {
      return 'Deseja que essa ação prossiga para o último nível de apreciação (Diretor/Gerente Geral UE)?';
    }

    // if (
    //   (!promote && !double && status === 'aprovado') ||
    //   status === 'rejeitado' ||
    //   (!data.stageNumber && (!status || status === 'aguardando'))
    // ) {
    //   return 'O que deseja fazer com essa entrega?';
    // } else
    if (
      managerType &&
      managerType !== 'equipe' &&
      (promote || double || (!data.stageNumber && (!status || status === 'aguardando')))
    ) {
      return 'O que deseja fazer com essa entrega?';

      // if (double) {
      //   // Matriz de apreciação - Não excluir
      //   // if (!userQuizAnswered && playerStep !== 5) {
      //   //   return (
      //   //     <>
      //   //       Uma matriz de orientação foi elaborada para auxiliar na apreciação das entrega. <br />
      //   //       Deseja utilizá-la?
      //   //     </>
      //   //   );
      //   // } else {
      //   return 'Deseja bonificar essa entrega?';
      //   // }
      // } else if (promote) {
      //   if (managerType === 'diretoria') {
      //     return 'Deseja premiar essa entrega com Selo Realização Destaque?';
      //   } else {
      //     return 'Deseja promover essa entrega?';
      //   }
      // } else {
      //   return 'Deseja enviar esta entrega para apreciação do Nível 3?';
      // }
    }

    return null;
  }, [data.stageNumber, double, managerType, pitStopCanEvaluate, promote, status]);

  const points = useMemo(() => (typeof data.multiplicador === 'number' ? data.multiplicador * 100 : 0), [data.multiplicador]);

  useEffect(() => {
    data?.team?.forEach((player: any) => {
      if (canExcludeParticipation(player) || canDecreaseParticipation(player)) {
        setOppened(true);
      }
    });
  }, [canExcludeParticipation, canDecreaseParticipation, data]);

  // useEffect(() => {
  //   data?.target?.forEach((player: any) => {
  //     if (canViewBoxApproveTeamMember(player)) {
  //       setOppened(true);
  //     }
  //   });
  // }, [canViewBoxApproveTeamMember, data]);

  useEffect(() => {
    // if (!!playerInfo && playerInfo.cod_etapa > 0) {
    //   loadFeedback();
    // }

    async function loadRealUser() {
      // const playerInfoResult = await getPlayerInfo(user?._id);

      if (playerInfo) {
        setRealPlayerInfo(playerInfo);

        // setHasFeedback(
        //   !!Array.isArray(data.feedback) &&
        //     !!data.feedback.find((x: { evaluatorId: any }) => x.evaluatorId === playerInfoResult.chave),
        // );
      }
    }

    if (data && user) {
      setStatus(data.status);

      if (
        !realPlayerInfo &&
        !!playerInfo &&
        playerInfo.ecoa &&
        (playerInfo.ecoa === 'TUTOR' || playerInfo?.ecoa === 'COORDENADOR')
      ) {
        loadRealUser();
      }
    }
  }, [data, user, playerInfo, realPlayerInfo]);

  useEffect(() => {
    if (!getAction?._id || !data?._id || data._id !== getAction._id) return;

    if (!!getAction?.fuction) {
      if (clearGetAction) {
        clearGetAction();
      }
      showModal(`${getAction.fuction}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, getAction]);

  useEffect(() => {
    async function openModalFeedback({ detail }: any) {
      if (data && detail && detail._id && detail._id === data?._id) {
        verifyFeedback();
      }
    }

    document.addEventListener('open:modal-feedback', openModalFeedback, false);

    return () => {
      document.removeEventListener('open:modal-feedback', openModalFeedback);
    };
  }, [data, verifyFeedback]);

  function capitalizeWords(str: string) {
    if (!str || str === '') return str;

    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return (
    <>
      <div className="task-item bg-maastricht-blue-3 rounded-[20px] text-white py-6 px-3 lg:p-8" key={data._id + '_task'}>
        <div className="relative flex flex-col lg:flex-row items-center justify-between space-y-2 lg:space-y-0 lg:space-x-3 pb-5 mb-5 border-b-2 border-prussian-blue">
          <div className="flex justify-between w-full flex-col-reverse lg:flex-row">
            <div className="flex-1 flex items-center space-x-3">
              <div>
                <UserAvatar data={data.owner_avatar} />
              </div>

              <Humanograma
                data={{
                  ...data,
                  nome: data.owner_name,
                  funcao: data.owner_funcao,
                  _id: data.owner,
                  prefixo: data.prefixo,
                  nome_dependencia: data.owner_nome_dependencia,
                }}
              >
                <div>
                  <p className="text-white text-base font-thin leading-none flex items-center space-x-1">
                    <strong className="font-semibold">{data.owner_name.split(' ')[0]}</strong> <span>({data.owner})</span>{' '}
                    <span className="hidden lg:block alice-blue">cadastrou</span>
                  </p>

                  <span className="font-thin lg:hidden">cadastrou:</span>
                  <p className="text-police-blue text-xs font-light leading-none mt-2">
                    {`Data do cadastro: ${format(new Date(data.created), 'd MMM. yy', {
                      locale: ptBR,
                    })}`}
                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                    {!!data.updated
                      ? `Última atualização: ${format(new Date(data.updated), 'd MMM. yy', {
                          locale: ptBR,
                        })}`
                      : ''}
                  </p>
                </div>
              </Humanograma>
            </div>

            {(!!editable || !!reset) && !isView && (
              <div className="w-full space-y-2 lg:space-y-0 lg:space-x-4 flex flex-col items-start  lg:flex-row lg:justify-end lg:w-auto mb-5 lg:my-0">
                {data.status === 'aguardando' && cycle && cycle.status === 'open' && data.owner === playerInfo?.chave && (
                  <button
                    onClick={() => showModal('confirm-delete', { id: data._id })}
                    type="button"
                    aria-label="Abrir diálogo para excluir ação"
                    aria-haspopup="dialog"
                    className={`text-[#ED2B48] lg:whitespace-nowrap flex-1 lg:flex-0 flex flex-row justify-end lg:justify-center items-center uppercase text-sm font-semibold`}
                  >
                    <BsTrash size={24} className="mr-2" aria-hidden="true" /> EXCLUIR AÇÃO
                  </button>
                )}

                {!!editable ? (
                  <button
                    onClick={handleEdit}
                    type="button"
                    aria-label="Abrir página para editar ação"
                    className={`text-azureish-white flex-1 lg:flex-0 flex flex-row justify-end lg:justify-center items-center uppercase text-sm font-semibold`}
                  >
                    <FiEdit3 size={24} className="mr-2" aria-hidden="true" /> EDITAR AÇÃO
                  </button>
                ) : null}

                {!!canViewResetButton ? (
                  <button
                    onClick={() => showModal(`validation-reset-${data._id}`)}
                    type="button"
                    aria-label="Abrir diálogo para desfazer apreciação"
                    aria-haspopup="dialog"
                    className={`text-azureish-white flex-1 lg:flex-0 flex flex-row justify-end lg:justify-center items-center uppercase text-sm font-semibold`}
                  >
                    <BiReset size={24} className="mr-2" aria-hidden="true" /> DESFAZER APRECIAÇÃO
                  </button>
                ) : null}
              </div>
            )}
          </div>
        </div>

        <div className="space-y-4 lg:space-y-7">
          {Array.isArray(managersByStep) && !!managersByStep.length && (
            <div>
              <h3 className="block text-base font-normal text-electric-blue mb-4">Acompanhe o andamento da ação</h3>
              <div className="flex justify-between space-x-1 mb-4">
                {managersByStep.map((manager: managersByStepProps, idx: number) => (
                  <div key={idx + '_timeline'} className="flex-1 w-full flex flex-col">
                    <p
                      className="flex items-center space-x-1 text-xs leading-none font-light mb-4 h-[18px]"
                      style={{
                        color: timeline(manager)?.titleColor || '',
                      }}
                    >
                      {!timeline(manager)?.opened ? <MdOutlineLock size={18} /> : null}
                      <span>{manager.stageTitle}</span>
                    </p>

                    <div className="flex justify-between items-stretch h-[10px] rounded-lg overflow-hidden mb-3">
                      <span
                        className="flex-1 w-full block h-full"
                        style={{
                          backgroundColor:
                            manager.stageNumber === 0 ? timeline(manager)?.bgColor : timeline(manager)?.bgColor1 || '',
                        }}
                      ></span>
                      {manager.stageNumber > 1 ? (
                        <>
                          <span className="w-[1px] block h-full"></span>
                          <span
                            className="flex-1 w-full block h-full"
                            style={{
                              backgroundColor: timeline(manager)?.bgColor2 || '',
                            }}
                          ></span>
                        </>
                      ) : null}
                    </div>

                    <p
                      className={`block text-sm leading-none ${
                        activeStage === manager.stageNumber ? 'font-normal' : 'font-light'
                      }`}
                      style={{
                        color: timeline(manager)?.statusColor || '',
                      }}
                    >
                      {timeline(manager)?.status || ''}
                    </p>

                    {Array.isArray(timeline(manager)?.gestor) ? (
                      <div className="flex items-center space-x-2 mt-3">
                        {timeline(manager)?.gestor.map((gestor: any, index: number) => (
                          <React.Fragment key={index}>
                            <Humanograma data={{ ...gestor, _id: gestor?.chave }}>
                              <p className="text-xs leading-none font-light">{capitalizeWords(gestor?.nome_guerra)}</p>
                            </Humanograma>
                            {timeline(manager)?.gestor?.length > 1 && index < timeline(manager)?.gestor.length - 1 && (
                              <span className="mx-1">/</span>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    ) : (
                      timeline(manager)?.gestor && (
                        <Humanograma data={{ ...timeline(manager)?.gestor, _id: timeline(manager)?.gestor?.chave }}>
                          <p className="text-xs leading-none font-light mt-3">
                            {capitalizeWords(timeline(manager)?.gestor?.nome_guerra)}
                          </p>
                        </Humanograma>
                      )
                    )}
                  </div>
                ))}
              </div>

              <p className="block text-sm font-semibold">
                Pontos recebidos: <strong className="text-base text-yellow font-semibold">{points}</strong>
              </p>
            </div>
          )}

          {/* {!!managerType && !!playerInfo && (
            <div className="space-y-3 lg:space-y-0 flex flex-col lg:flex-row justify-between">
              <div>
                <p className="text-sm font-thin text-electric-blue">Fluxo de Apreciação:</p>
                <p className="text-base font-normal text-white m-0">{stepLabel}</p>
              </div>
              <div>
                <p className="text-sm font-thin text-electric-blue">Prefixo desta entrega:</p>
                <p className="text-base font-normal text-white m-0">{data.prefixo}</p>
              </div>
            </div>
          )} */}

          <div>
            <p className="text-sm font-thin text-electric-blue">Nome da ação</p>
            <p className="text-base font-normal text-white m-0">{data.title || '---'}</p>
          </div>

          {!!oppened ? (
            <>
              <div>
                <p className="text-sm font-thin text-electric-blue">Detalhes da ação</p>
                <p
                  className="text-base font-normal text-white m-0"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof data.description === 'string'
                        ? data.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
              <div>
                <p className="text-sm font-thin text-electric-blue">Resultado da ação</p>
                <p
                  className="text-base font-normal text-white m-0"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof data.result === 'string'
                        ? data.result.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>

              {!!data.indicator?.nome || !!data.participants_approval?.status ? (
                <div className="space-y-3 lg:space-y-0 flex flex-col lg:flex-row justify-between">
                  {!!data.indicator?.nome && (
                    <div className={!!data.participants_approval?.status ? `lg:w-1/2` : 'lg:w-full'}>
                      <p className="text-sm font-thin text-electric-blue">Indicador</p>
                      <p className="text-base font-normal text-white m-0">{data.indicator?.nome || '---'}</p>
                    </div>
                  )}

                  {!!data.participants_approval?.status && (
                    <div className={!!data.indicator?.nome ? `lg:w-1/3` : 'lg:w-full'}>
                      <p className="text-sm font-thin text-electric-blue">Status de participação</p>
                      <p className="text-base font-normal text-white m-0">
                        {cycle?.status !== 'open' && data.participants_approval.status === 'pending'
                          ? getStatusApprovalParticipants.rejected
                          : getStatusApprovalParticipants[data.participants_approval.status]}
                      </p>
                    </div>
                  )}
                </div>
              ) : null}

              {!!data?.nec?.cd_alcc && !!data?.nec?.nm_uor_sltt ? (
                <div className="space-y-3 lg:space-y-0 flex flex-col lg:flex-row justify-between">
                  <div className="lg:w-1/2">
                    <p className="text-sm font-thin text-electric-blue">NEC</p>
                    <p className="text-base font-normal text-white m-0">{data?.nec?.cd_alcc + ' - ' + data?.nec?.nm_alcc}</p>
                  </div>

                  <div className="lg:w-1/3">
                    <p className="text-sm font-thin text-electric-blue">Demandante</p>
                    <p className="text-base font-normal text-white m-0">{data?.nec?.nm_uor_sltt}</p>
                  </div>
                </div>
              ) : null}

              <div className="space-y-3 lg:space-y-0 flex flex-col lg:flex-row justify-between">
                <div className="lg:w-1/3">
                  <p className="text-sm font-thin text-electric-blue">Período da entrega</p>
                  <p className="text-base font-normal text-white m-0">
                    {getFormattedDate(data.start)} a {getFormattedDate(data.end)}
                  </p>
                </div>
                {!!data.nec?.length && (
                  <div className="lg:w-1/3">
                    <p className="text-sm font-thin text-electric-blue">NEC - Necessidade de TI</p>
                    <p className="text-base font-normal text-white m-0">{data.nec}</p>
                  </div>
                )}
              </div>

              {/* <div className="space-y-3 lg:space-y-0 flex flex-col-reverse lg:flex-row justify-between">
                <div className="lg:w-1/3">
                  <p className="text-sm font-thin text-electric-blue">Status da entrega</p>
                  <p className="text-base font-normal text-white m-0">
                    {GetTaskLevelLabel(isCurrentEvaluator() ? 'aguardando' : data.status)}
                  </p>
                </div>

                {data.evaluator &&
                data.evaluator.length > 0 &&
                !isNaN(Number(data.evaluator[data.evaluator.length - 1])) &&
                !!getEvaluatorData(data) &&
                data.status !== 'concluido' &&
                data.status !== 'concluidoAuto' &&
                data.status !== 'apreciacaoExpirada' &&
                data.status !== 'selo' ? (
                  <div className="lg:w-1/3">
                    <p className="text-sm font-thin text-electric-blue">Sendo avaliado por</p>
                    <p className="text-base font-normal text-white m-0">
                      {getEvaluatorData(data).chave} - {getEvaluatorData(data).nome_guerra}
                    </p>
                  </div>
                ) : null}

                <div className="lg:w-1/3">
                  <p className="text-sm font-thin text-electric-blue">Pontos a receber</p>
                  <p className="text-base font-normal text-white m-0">{points}</p>
                </div>
              </div> */}

              {!!data.feedback?.length &&
                !isView &&
                data.feedback
                  .sort((a: any, b: any) => b.etapa - a.etapa)
                  .map((feedback: any, index: number) => (
                    <div key={feedback._id + '_feedback'}>
                      {index === 0 && (
                        <button
                          onClick={() => setShowFeedbacks(!showFeedbacks)}
                          type="button"
                          aria-label={`Feedbacks ${showFeedbacks ? 'recolhido' : 'expandido'}`}
                          aria-expanded={showFeedbacks}
                          className="text-electric-blue flex items-center space-x-2 cursor-pointer"
                        >
                          <p className="text-sm font-thin text-electric-blue">
                            Feedback {feedback.evaluatorId !== 'F0000000' ? 'do gestor' : ''}
                          </p>

                          {showFeedbacks ? <IoIosArrowUp size={20} aria-hidden="true" /> : <IoIosArrowDown size={20} aria-hidden="true" />}
                        </button>
                      )}

                      {showFeedbacks &&
                        (feedback.evaluatorId === 'F0000000' ? (
                          <>
                            <p className="text-base font-light text-white m-0 w-fit">
                              {/* {getStepLabel(feedback.etapa).length ? `${getStepLabel(feedback.etapa)}: ` : ''} */}
                              {getStepLabel(feedback.etapa) === 'Validação' ? 'Avaliado' : 'Apreciado'} por{' '}
                              {feedback.evaluator_nome_guerra}
                            </p>
                            <p
                              className="text-base font-light text-white m-0 italic"
                              dangerouslySetInnerHTML={{
                                __html: feedback.message,
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <a
                              href={`https://humanograma.intranet.bb.com.br/${feedback.evaluatorId}`}
                              target="_blank"
                              rel="noreferrer"
                              className="hover:text-white  focus:text-white w-fit"
                            >
                              <Tippy
                                allowHTML
                                content={
                                  <>
                                    <p className="m-0">
                                      <strong>{`${feedback.evaluator_nome} (${feedback.evaluatorId})`}</strong>
                                    </p>

                                    <p className="m-0 mt-2 text-electric-blue">Clique para o Humanograma</p>
                                  </>
                                }
                              >
                                <p className="text-base font-light text-white m-0 w-fit">
                                  {getStepLabel(feedback.etapa).length ? `${getStepLabel(feedback.etapa)}: ` : ''}
                                  {getStepLabel(feedback.etapa) === 'Validação' ? 'Avaliado' : 'Apreciado'} por{' '}
                                  {feedback.evaluator_nome_guerra}
                                </p>
                              </Tippy>{' '}
                            </a>
                            <p
                              className="text-base font-light text-white m-0 italic"
                              dangerouslySetInnerHTML={{
                                __html: feedback.message,
                              }}
                            />
                          </>
                        ))}
                    </div>
                  ))}

              {!!data.target?.length && (
                <div className="space-y-3 lg:space-y-4 flex flex-col w-full">
                  <p className="text-base font-semibold leading-none m-0 text-yellow">
                    Participantes da ação {`(${data.target?.length})`}
                  </p>

                  {data.target
                    .sort((a: any, b: any) => {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })
                    .map((player: any) => (
                      <div
                        key={player._id + '_target'}
                        className={`flex flex-col bg-oxford-blue py-3 px-8 rounded-lg ${
                          canExcludeParticipation(player) || canDecreaseParticipation(player)
                            ? 'border border-electric-blue border-dotted border-opacity-40'
                            : ''
                        }`}
                      >
                        <div className="flex flex-col lg:flex-row lg:items-center space-y-2 lg:space-y-0 lg:space-x-4">
                          <div className="flex-1 flex flex-row items-center text-white space-x-3">
                            <UserAvatar data={{ ...player, ...player.extra }} />
                            <Humanograma data={{ ...player?.extra, _id: player._id, nome: player.name }}>
                              <span className="text-base font-thin text-white m-0">
                                <span className="font-light">{player?.extra?.nome_guerra.split(' ')[0]}</span> ({player._id})
                                <p className="m-0 text-blue-light text-sm">
                                  {player?.extra?.funcao} - {player?.extra?.prefixo} - {player?.extra?.nome_dependencia}
                                </p>
                                {/* {!!showMessageRequiresApproval(player) ? (
                                <>
                                  <br />
                                  <span className="text-xs text-electric-blue leading-none block italic">
                                    Requer aprovação da participação pelo gestor
                                  </span>
                                </>
                              ) : null} */}
                              </span>
                            </Humanograma>
                          </div>

                          {!ecoa && (
                            <div className="bg-maastricht-blue px-4 py-2 text-xs font-thin leading-none text-yellow rounded-full flex items-center">
                              {getUserTeam(player._id)?.percent || '0'}% de atuação
                            </div>
                          )}

                          {canDecreaseParticipation(player) && (
                            <div>
                              <Tippy
                                allowHTML
                                content={
                                  <>
                                    <p className="m-0 block text-center">
                                      {isParticipantManager(player)
                                        ? `Você pode diminuir esse percentual de atuação`
                                        : 'Você pode diminuir seu percentual de atuação'}
                                      .
                                    </p>
                                  </>
                                }
                              >
                                <button
                                  type="button"
                                  aria-label={`Abrir diálogo para diminuir percentual de atuação${isParticipantManager(player) ? ' do participante' : ''}`}
                                  aria-haspopup="dialog"
                                  className={`text-[#ED2B48] text-sm font-semibold block`}
                                  onClick={() => {
                                    setUserToChange(player._id);
                                    showModal(`team-member-decrease-${data._id}`);
                                  }}
                                >
                                  <LuArrowDownWideNarrow size={28} aria-hidden="true" />
                                </button>
                              </Tippy>
                            </div>
                          )}

                          {canExcludeParticipation(player) && (
                            <div>
                              <Tippy
                                allowHTML
                                content={
                                  <>
                                    <p className="m-0 block text-center">
                                      {isParticipantManager(player)
                                        ? `Você pode excluir essa participação`
                                        : 'Você pode excluir sua participação'}
                                      .
                                    </p>
                                  </>
                                }
                              >
                                <button
                                  type="button"
                                  aria-label={`Abrir diálogo para excluir participação${isParticipantManager(player) ? ' do participante' : ''}`}
                                  aria-haspopup="dialog"
                                  className={`text-[#ED2B48] text-sm font-semibold block`}
                                  onClick={() => {
                                    setUserToChange(player._id);
                                    showModal(`team-member-exclude-${data._id}`);
                                  }}
                                >
                                  <RiProhibitedLine size={28} aria-hidden="true" />
                                </button>
                              </Tippy>
                            </div>
                          )}
                        </div>
                        {/* {canViewBoxApproveTeamMember(player) ? (
                        <div className="w-full border-t-2 border-prussian-blue mt-4 pt-4 pb-2 lg:mt-6 lg:pt-6 lg:pb-3 block">
                          <p className="text-sm text-alice-blue block text-center mb-4 lg:mb-7 font-light">
                            Deseja aceitar a indicação do funcionário a esta ação?
                          </p>
                          <div className="flex items-center justify-center space-x-16">
                            <button
                              className="text-[#04D475] uppercase text-sm p-0 m-0 font-normal block"
                              onClick={() => [
                                showModal(`validation-team-member-accept-${data._id}`),
                                setValidateTeamMember(player._id),
                              ]}
                            >
                              ACEITAR
                            </button>
                            <button
                              className="text-[#ED2B48] uppercase text-sm p-0 m-0 font-normal block"
                              onClick={() => [
                                showModal(`validation-team-member-reject-${data._id}`),
                                setValidateTeamMember(player._id),
                              ]}
                            >
                              RECUSAR
                            </button>
                          </div>
                        </div>
                      ) : null} */}
                      </div>
                    ))}
                </div>
              )}
            </>
          ) : null}

          <button
            onClick={() => setOppened(prev => !prev)}
            type="button"
            aria-label={`Informações da ação ${!oppened ? 'expandidas' : 'recolhidas'}`}
            aria-expanded={oppened}
            className="mt-8 p-0 uppercase space-x-1 leading-none text-grey-dark text-sm font-normal flex items-center justify-center mx-auto"
          >
            {!oppened ? <IoIosArrowDown size={20} aria-hidden="true" /> : <IoIosArrowUp size={20} aria-hidden="true" />}{' '}
            <span>Ver {!!oppened ? 'menos' : 'mais'} informações</span>
          </button>
        </div>

        {(canViewBoxActions() || pitStopCanEvaluate) && !isView ? (
          <>
            <div className="w-full border-t-2 border-prussian-blue mt-4 pt-4 lg:mt-6 lg:pt-6 block">
              {pitStopCanEvaluate ? (
                <h3 className="text-electric-blue text-base leading-none mb-7 font-light block text-center">
                  Essa Realização Destaque foi promovida pela sua Rede.
                </h3>
              ) : null}

              {!!questionTitle && (
                <h3 className="mb-8 p-0 leading-none block text-center font-light text-alice-blue text-base">{questionTitle}</h3>
              )}

              <div className="flex flex-row space-x-16 justify-center items-center">
                {/* {!promote && !double && status === 'aprovado' ? (
                  <>
                    <button
                      className={`cursor-default text-opacity-60 text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <HiOutlineHandThumbUp className="text-xl" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">Validada</span>
                    </button>
                  </>
                ) : null}

                {status === 'rejeitado' ? (
                  <>
                    <button
                      className={`cursor-default text-opacity-60 text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <HiOutlineHandThumbDown className="text-xl" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">Devolvida</span>
                    </button>
                  </>
                ) : null} */}

                {!data.stageNumber && (!status || status === 'aguardando') && (
                  <>
                    {canValidate && (
                      <button
                        onClick={() => showModal(`validation-accept-${data._id}`)}
                        type="button"
                        aria-label="Abrir diálogo para validar ação"
                        aria-haspopup="dialog"
                        className={`text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                      >
                        <HiOutlineHandThumbUp className="text-xl" aria-hidden="true" />{' '}
                        <span className="uppercase leading-none text-sm font-normal">Validar</span>
                      </button>
                    )}

                    <button
                      onClick={() => showModal(`validation-known-${data._id}`)}
                      type="button"
                      aria-label="Abrir diálogo para marcar como ciente"
                      aria-haspopup="dialog"
                      className={`text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <FiEye className="text-xl" aria-hidden="true" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">Dar como ciente</span>
                    </button>
                  </>
                )}

                {promote || double || pitStopCanEvaluate || canFinalize ? (
                  <>
                    {double || canFinalize ? (
                      // Matriz de apreciação - Não excluir
                      // !userQuizAnswered && playerStep !== 5 ? (
                      //   <>
                      //     <button
                      //       onClick={() => setShowModalMatriz(true)}
                      //       className={`text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                      //     >
                      //       <HiOutlineHandThumbUp className="text-xl" />{' '}
                      //       <span className="uppercase leading-none text-sm font-normal">SIM</span>
                      //     </button>

                      //     <button
                      //       onClick={() => showModal(`validation-stop-quiz-${data._id}`)}
                      //       className={`text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                      //     >
                      //       <HiOutlineHandThumbDown className="text-xl" />{' '}
                      //       <span className="uppercase leading-none text-sm font-normal">NÃO</span>
                      //     </button>
                      //   </>
                      // ) : (
                      <>
                        {double && (
                          <button
                            onClick={() =>
                              !!doubleByPassCod5 && typeof onDouble === 'function'
                                ? onDouble(data)
                                : showModal(`validation-double-${data._id}`)
                            }
                            type="button"
                            aria-label="Abrir diálogo para bonificar ação"
                            aria-haspopup="dialog"
                            className={`text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                          >
                            <span className="uppercase leading-none text-sm font-normal">Bonificar</span>
                          </button>
                        )}

                        <button
                          onClick={() => showModal(`validation-stop-${data._id}`, { type: 'double' })}
                          type="button"
                          aria-label="Abrir diálogo para finalizar apreciação"
                          aria-haspopup="dialog"
                          className={`text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                        >
                          <span className="uppercase leading-none text-sm font-normal">Finalizar</span>
                        </button>
                      </>
                    ) : // )
                    null}

                    {promote || pitStopCanEvaluate ? (
                      <>
                        <Tippy
                          arrow={false}
                          className="bg-yellow drop-shadow-lg text-white"
                          allowHTML={true}
                          content={
                            pitStopCanEvaluate
                              ? 'Você deve avaliar se essa entrega irá prosseguir para o último nível de apreciação (Diretor/Gerente Geral UE)'
                              : managerType && managerType === 'diretoria'
                                ? 'Podem receber Selos Realização Destaque até 10% das entregas bonificadas neste nível (com arredomento para cima)'
                                : 'Podem ser promovidas até 10% das entregas bonificadas neste nível (com arredomento para cima)'
                          }
                        >
                          <button
                            onClick={() =>
                              managerType && managerType === 'diretoria'
                                ? showModal(`validation-selo-${data._id}`)
                                : showModal(`validation-promote-${data._id}`)
                            }
                            type="button"
                            aria-label={`Abrir diálogo para ${managerType && managerType === 'diretoria' ? 'premiar com selo' : pitStopCanEvaluate ? 'permitir prosseguimento' : 'promover ação'}`}
                            aria-haspopup="dialog"
                            className={`text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                          >
                            {/* <HiOutlineHandThumbUp className="text-xl" />{' '} */}
                            <span className="uppercase leading-none text-sm font-normal">
                              {managerType && managerType === 'diretoria'
                                ? 'Premiar com Selo Realização Destaque'
                                : pitStopCanEvaluate
                                  ? 'SIM'
                                  : 'Promover'}
                            </span>
                            {/* {managerType && managerType === 'diretoria' ? (
                                  <TfiMedallAlt className="text-xl" />
                                ) : (
                                  <BiUpvote className={`text-xl ${pitStopCanEvaluate ? 'rotate-90 transform' : ''}`} />
                                )}{' '}
                                <span className="uppercase leading-none text-sm font-normal">
                                  {managerType && managerType === 'diretoria'
                                    ? 'Indicar Selo'
                                    : pitStopCanEvaluate
                                    ? 'Prosseguir'
                                    : 'Promover'}
                                </span> */}
                          </button>
                        </Tippy>

                        {pitStopCanEvaluate ? (
                          <Tippy
                            arrow={false}
                            className="bg-yellow drop-shadow-lg text-white"
                            allowHTML={true}
                            content={
                              'Você deve avaliar se essa entrega será concluída neste nível e não será enviada para o último nível de apreciação (Diretor/Gerente Geral UE).'
                            }
                          >
                            <button
                              onClick={() => showModal(`validation-stop-${data._id}`, { type: 'pitstop' })}
                              type="button"
                              aria-label="Abrir diálogo para não permitir prosseguimento"
                              aria-haspopup="dialog"
                              className={`text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                            >
                              <span className="uppercase leading-none text-sm font-normal">NÃO</span>
                            </button>
                          </Tippy>
                        ) : (
                          <button
                            onClick={() => showModal(`validation-stop-${data._id}`, { type: 'promote' })}
                            type="button"
                            aria-label="Abrir diálogo para finalizar apreciação"
                            aria-haspopup="dialog"
                            className={`text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                          >
                            <span className="uppercase leading-none text-sm font-normal">Finalizar</span>
                          </button>
                        )}
                      </>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
          </>
        ) : canViewBoxActions() && !!canApproveParticipants ? (
          <>
            <div className="w-full border-t-2 border-prussian-blue mt-4 pt-4 lg:mt-6 lg:pt-6 block">
              <h3 className="mb-8 p-0 leading-none block text-center font-light text-alice-blue text-base">
                Esta ação possui {data?.team?.length} participantes. Você autoriza esse número de participantes?
              </h3>

              <div className="flex flex-row space-x-16 justify-center items-center">
                {data?.participants_approval?.status === 'approved' ? (
                  <>
                    <button
                      className={`cursor-default text-opacity-60 text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <HiOutlineHandThumbUp className="text-xl" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">SIM</span>
                    </button>
                  </>
                ) : null}

                {data?.participants_approval?.status === 'rejected' ? (
                  <>
                    <button
                      className={`cursor-default text-opacity-60 text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <HiOutlineHandThumbDown className="text-xl" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">NÃO</span>
                    </button>
                  </>
                ) : null}

                {data?.participants_approval?.status === 'pending' && cycle?.status === 'open' && (
                  <>
                    <button
                      onClick={() => showModal(`validation-participants-accept-${data._id}`)}
                      type="button"
                      aria-label="Abrir diálogo para autorizar número de participantes"
                      aria-haspopup="dialog"
                      className={`text-[#04D475] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <HiOutlineHandThumbUp className="text-xl" aria-hidden="true" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">SIM</span>
                    </button>
                    <button
                      onClick={() => showModal(`validation-participants-reject-${data._id}`)}
                      type="button"
                      aria-label="Abrir diálogo para rejeitar número de participantes"
                      aria-haspopup="dialog"
                      className={`text-[#ED2B48] space-x-2 inline-flex justify-center items-center uppercase leading-none text-sm`}
                    >
                      <HiOutlineHandThumbDown className="text-xl" aria-hidden="true" />{' '}
                      <span className="uppercase leading-none text-sm font-normal">NÃO</span>
                    </button>
                  </>
                )}
              </div>
            </div>
          </>
        ) : null}

        {canSendFeedback() && typeof hasFeedback === 'boolean' ? (
          <div className="mt-14">
            <h3 className="mb-8 p-0 leading-none block text-center font-light text-alice-blue text-base">
              Conte à equipe o que achou dessa entrega:
            </h3>

            {!hasFeedback ? (
              <>
                <button
                  onClick={() => showModal(`validation-feedback-${data._id}`)}
                  type="button"
                  aria-label="Abrir diálogo para enviar feedback da ação"
                  aria-haspopup="dialog"
                  className={`text-[#DCE3F8] space-x-2 mx-auto flex justify-center items-center uppercase leading-none text-sm`}
                >
                  <RiMessage2Line className="text-xl" aria-hidden="true" />{' '}
                  <span className="uppercase leading-none text-sm font-normal">Enviar feedback</span>
                </button>
              </>
            ) : (
              <>
                <button
                  disabled
                  type="button"
                  aria-label="Feedback já enviado para esta ação"
                  className={`cursor-default text-opacity-60 text-[#DCE3F8] space-x-2 mx-auto flex justify-center items-center uppercase leading-none text-sm`}
                >
                  <RiMessage2Line className="text-xl" aria-hidden="true" />{' '}
                  <span className="uppercase leading-none text-sm font-normal">Feedback enviado</span>
                </button>
              </>
            )}
          </div>
        ) : null}

        {evaluationData}
      </div>

      <ModalActions
        callback={callBackActions}
        id={data._id}
        status={status}
        data={data}
        playerInfo={playerInfo}
        validateTeamMember={validateTeamMember}
        activeEvaluationStep={activeEvaluationStep as number}
        bonus={bonus}
        userToChange={userToChange}
        ecoa={ecoa}
      />

      <ModalConfirm callback={item => handleDelete(item.id)} />

      {/* // Matriz de apreciação - Não excluir */}
      {/* {showModalMatriz && (
        <Matriz
          onClose={() => setShowModalMatriz(false)}
          setQuizAnswered={() => setQuizAnswered(true)}
          taskId={data._id}
          playerInfo={playerInfo}
        />
      )} */}
    </>
  );
}
